import {
  Box,
  Typography,
} from "@mui/material";
import ContentShimmer from "react-content-shimmer";
import { useEffect } from "react";

import VerificationLayout from "../../layout/VerificationLayout.component";
import Theme from "../../../utils/Theme";
import { useVerification } from "../../../context/Verification.context";
import { FETCH_VERIFICATION_URL } from "../../../graphql/query/query";
import { useAuth } from "../../../context/Auth.context";
import { useQuery } from "@apollo/client";
import GetUserDetails from "../../base/GetUserDetails.component";
import AppButton from "../../base/AppButton.component";
import { useAppContext } from "../../../context/App.context";
import { useNavigate } from "react-router-dom";



const OmniUserDetails = () => {
  const verification = useVerification();
  const auth = useAuth();
  const app = useAppContext();
  const navigate = useNavigate();

  const { data, loading } = useQuery(FETCH_VERIFICATION_URL, {
    variables: {
      verificationInput: {
        employee_user_id: auth?.user?.user_id,
        dealership_id: auth?.user?.dealership_id,
      },
    },
    skip: !auth?.user?.user_id || !auth?.user?.dealership_id,
  });

  useEffect(() => {
    if (data?.fetchVerificationUrl) {
      const getImage = data?.fetchVerificationUrl?.image_url;
      verification.setDealershipLogo(getImage);
    }
  }, [data]);

  useEffect(() => {
    verification.setEmployeeId(auth?.user?.user_id);
    verification.setDealershipId(auth?.user?.dealership_id);
  }, [auth?.user?.user_id, auth?.user?.dealership_id]);

  const handleClose = () => {
    auth.logout();
    app.removeAll();
    navigate("/express");
  };

  return (
    <>
      <VerificationLayout>
        <Box
          display={"flex"}
          justifyContent={"center"}
          flexDirection={"column"}
          width={{
            xs: 300,
            sm: 300,
            md: 360,
            lg: 600,
          }}
          height={{
            xs: 600,
            sm: 400,
            md: 600,
            lg: 1200,
          }}
        >
          {/* ── Header: centered logo + EXIT ───────────────────────── */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              width: "100%",
              marginTop: "28px",
              marginBottom: "16px",
            }}
          >
            {!verification?.dealershipLogo || loading ? (
              <ContentShimmer
                size={{
                  height: window.innerWidth <= 750 ? 30 : 60,
                  width: window.innerWidth <= 750 ? 90 : 150,
                }}
              />
            ) : (
              <img
                src={verification?.dealershipLogo}
                width={100}
                height={60}
                alt="logo"
                style={{
                  objectFit: "contain",
                }}
              />
            )}

            <AppButton
              buttonText={"EXIT"}
              variant={"text"}
              sx={{
                position: "absolute",
                right: 0,
                color: Theme.palette.error.main,
              }}
              clickHandler={handleClose}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              mb: 2,
            }}
          >
            <Typography
              variant="body1"
              align="center"
              sx={{ flex: 1, textAlign: "center" }}
            >
              Please enter your details
            </Typography>
          </Box>

          <GetUserDetails isURL={true} OmniUser={true} />
        </Box>
      </VerificationLayout>
    </>
  );
};
export default OmniUserDetails;